<template>
    <div class="flex mb-1">
        <InputNumber class="w-full pr-1" v-model="locationQuantity" type="integer"  placeholder="Quantity" @input="bindData"/>
    
        <InputText v-model="queryLocation" class="w-full mr-1" placeholder="Search a location..." ></InputText>
    
        <Dropdown class="w-full pr-1" v-model="deliveryLocation" editable :options="filteredLocations" optionLabel="name" optionValue="id" placeholder="Select a location" style="width:9em; height:2.5em" @change="bindData"/>
    
        <Button size="small" icon="pi pi-trash" class="ml-1" text raised  severity="danger" @click="$emit('delete')" aria-label="Cancel" @change="bindData" v-tooltip.top="'Delete location'"/> <br>

    </div>
</template>

<script>
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'

export default {

    props:{
        itemDetails:Object,
        quantity:Number,
        index:Number,
        dbLocations:Array
    },

    emits:['bind-item', 'delete'],
    components:{
        InputNumber,
        InputText,
        Button,
        Dropdown
    },

    data(){
        return{
            locationQuantity:0,
            deliveryLocation:null,
            locations:[],
            queryLocation:null,
        }
    },
    computed:{
        filteredLocations() {
            return this.locations.filter(l => l.name?.toLowerCase().includes(this.queryLocation?.toLowerCase()))
        }
    },
    methods:{
        bindData(){
            
            const itemdata = {
                itemId: this.itemDetails.id,
                locationQuantity:this.locationQuantity,
                deliveryLocation:this.deliveryLocation
            };
           
            this.$emit('bind-item', this.index, itemdata)
        },
    },
    mounted(){
        this.locationQuantity = this.quantity;
        this.locations = this.dbLocations;
    }

}
</script>

<style>

</style>